import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaChartBar, FaCalendarAlt, FaDumbbell, FaWeight } from 'react-icons/fa';
import '../styles/BottomNavBar.css';

const BottomNavBar = () => {
  return (
    <div className="bottom-nav-bar">
      <NavLink to="/home/stats" className={({ isActive }) => (isActive ? 'active' : '')}>
        <FaChartBar />
        <span>Stats</span>
      </NavLink>
      <NavLink to="/home/calendar" className={({ isActive }) => (isActive ? 'active' : '')}>
        <FaCalendarAlt />
        <span>Calendar</span>
      </NavLink>
      <NavLink to="/home/workout" className={({ isActive }) => (isActive ? 'active' : '')}>
        <FaDumbbell />
        <span>Workout</span>
      </NavLink>
      <NavLink to="/home/scales" className={({ isActive }) => (isActive ? 'active' : '')}>
        <FaWeight />
        <span>Scales</span>
      </NavLink>
    </div>
  );
};


export default BottomNavBar;
